import api from "@/lib/api";
import { toast } from "sonner";
import { logEvent } from "@/lib/analytics";

// Additive Sample Portfolio helpers — isolated demo data tagged is_demo on the backend.
export async function getSampleStatus() {
  const r = await api.get("/demo/sample-portfolio");
  return r.data; // { loaded, count }
}

export async function loadSamplePortfolio() {
  const r = await api.post("/demo/sample-portfolio");
  logEvent("sample_portfolio_loaded", { count: r.data?.created ?? 0 });
  return r.data;
}

export async function clearSamplePortfolio() {
  const r = await api.delete("/demo/sample-portfolio");
  logEvent("sample_portfolio_cleared", { deleted: r.data?.deleted ?? 0 });
  return r.data;
}

// Premium in-app experience: dispatch an event picked up by <SamplePortfolioExperience/>
// (mounted in Layout) which runs the cinematic loader → money-stuck reveal → guided tour.
// `toast` kept as an optional arg for backward-compatible call sites.
export function exploreSampleAndGo(/* toast */) {
  logEvent("sample_experience_started", {});
  window.dispatchEvent(new CustomEvent("recoveros:start-sample"));
}

export const SAMPLE_PHASE_KEY = "ros_sample_phase";
export const START_SAMPLE_KEY = "ros_start_sample";

// One-shot request to launch the sample experience on the Dashboard. Used from screens
// rendered OUTSIDE the app Layout (e.g. the /welcome onboarding page), where the
// <SamplePortfolioExperience/> orchestrator isn't mounted. Set the flag, then route to
// /dashboard — the orchestrator reads & clears it on mount and auto-starts.
export function requestSampleStart(navigate) {
  logEvent("sample_experience_started", { source: "onboarding" });
  sessionStorage.setItem(START_SAMPLE_KEY, "1");
  navigate("/dashboard");
}

// Sample → Add One Account — the low-commitment real-data path from sample mode. Fires a
// funnel event and opens the global Quick Add dialog (mounted in Layout). We do NOT auto-clear
// the sample here: on successful create the dialog routes to the new account's detail, and the
// user can still "Clear demo" from the invite banner whenever they want.
export function addOneAccountFromSample(source = "sample") {
  logEvent("sample_add_account_cta", { source });
  window.dispatchEvent(new CustomEvent("recoveros:quick-add", { detail: { source } }));
}

// Import Handoff — auto-clear the sample/demo portfolio (so the real upload lands in a
// clean workspace) and drop the user straight onto the import Upload step. Non-blocking:
// if the clear fails we still route to /import so the user is never stuck.
export async function importRealData(navigate, source = "unknown") {
  logEvent("sample_import_cta", { source });
  const t = toast.loading("Clearing sample data & opening import…");
  try {
    await clearSamplePortfolio();
    window.dispatchEvent(new Event("recoveros:sample-done"));
    toast.success("Sample cleared — now import your real portfolio", { id: t });
  } catch (e) {
    toast.error("Couldn't clear sample data — you can clear it later from the banner", { id: t });
  } finally {
    navigate("/import");
  }
}

